// §4.4 partial — settings route.
// The original app had no standalone /settings page (settings was a dashboard modal).
// We expose /settings as a redirect to /preferences for backward-compat.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";

const SettingsPage = lazyWithRetry(() => import("./pages/SettingsPage"));

const routes: RouteObject[] = [{ path: "/settings", Component: SettingsPage }];

export default routes;
